<template>
    <v-select
        @input="onChangeHandler"
        :value="value.length > 0 ? value : null"
        :options="gradeItems"
        :placeholder="placeholder"
        label="label"
        multiple
    >
        <template slot="option" slot-scope="option">
            <div class="d-flex py-1">
                <p class="mb-0 text-capitalize">{{ option.label }}</p>
            </div>
        </template>
    </v-select>
</template>

<script>
import datalist from '../../../frontend/src/mixins/datalist'

export default {
    mixins: [datalist],

    props: {
        placeholder: {
            type: String,
            default: 'Select grade'
        },
        value: {
            type: Array,
            default: null
        }
    },

    data() {
        return {
            gradeItems: []
        }
    },

    mounted() {
        this.gradeItems = this.gradeList.map(grade => {
            return { label: grade.label.replace('_', ' '), value: grade.value }
        })
    },

    methods: {
        onChangeHandler(value) {
            this.$emit('select', value)
        }
    }
}
</script>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
